import { render, staticRenderFns } from "./NewUserLevelStat.vue?vue&type=template&id=2ce30d2e&scoped=true&"
import script from "./NewUserLevelStat.vue?vue&type=script&lang=js&"
export * from "./NewUserLevelStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce30d2e",
  null
  
)

export default component.exports